var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadBenefit3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "094_\\u8BA1\\u7B97\\u5668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M20.9641 25.9996L5.03553 25.9996C2.25913 25.9996 0 23.7409 0 20.9641L0 5.03553C0 2.25913 2.25874 0 5.03553 0L20.9645 0C23.7409 0 26 2.25874 26 5.03553L26 20.9645C26 23.7409 23.7413 26 20.9645 26L20.9641 25.9996ZM5.03553 1.55454C3.11607 1.55454 1.55454 3.11607 1.55454 5.03553L1.55454 20.9645C1.55454 22.8839 3.11607 24.4455 5.03553 24.4455L20.9645 24.4455C22.8839 24.4455 24.4455 22.8839 24.4455 20.9645L24.4455 5.03553C24.4455 3.11607 22.8839 1.55454 20.9645 1.55454L5.03553 1.55454Z",
    fill: "rgb(51,51,51)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M11.0007 9.09409L6.02617 9.09409C5.59673 9.09409 5.2489 8.74626 5.2489 8.31682C5.2489 7.88738 5.59673 7.53955 6.02617 7.53955L11.0007 7.53955C11.4301 7.53955 11.778 7.88738 11.778 8.31682C11.778 8.74626 11.4301 9.09409 11.0007 9.09409Z",
    fill: "rgb(141,86,233)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M20.7134 9.09409L15.7389 9.09409C15.3094 9.09409 14.9616 8.74626 14.9616 8.31682C14.9616 7.88738 15.3094 7.53955 15.7389 7.53955L20.7134 7.53955C21.1428 7.53955 21.4907 7.88738 21.4907 8.31682C21.4907 8.74626 21.1428 9.09409 20.7134 9.09409Z",
    fill: "rgb(51,51,51)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M20.2859 17.2165L16.1664 17.2165C15.737 17.2165 15.3891 16.8687 15.3891 16.4392C15.3891 16.0098 15.737 15.662 16.1664 15.662L20.2859 15.662C20.7154 15.662 21.0632 16.0098 21.0632 16.4392C21.0632 16.8687 20.7154 17.2165 20.2859 17.2165ZM20.2859 20.0924L16.1664 20.0924C15.737 20.0924 15.3891 19.7446 15.3891 19.3151C15.3891 18.8857 15.737 18.5378 16.1664 18.5378L20.2859 18.5378C20.7154 18.5378 21.0632 18.8857 21.0632 19.3151C21.0632 19.7446 20.7154 20.0924 20.2859 20.0924ZM8.51341 11.5813C8.08397 11.5813 7.73615 11.2335 7.73615 10.804L7.73615 5.82951C7.73615 5.40007 8.08397 5.05225 8.51341 5.05225C8.94285 5.05225 9.29068 5.40007 9.29068 5.82951L9.29068 10.804C9.29068 11.2335 8.94285 11.5813 8.51341 11.5813Z",
    fill: "rgb(141,86,233)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M6.4513 20.6754C6.25232 20.6754 6.05334 20.5996 5.90178 20.4477C5.59825 20.1442 5.59825 19.6521 5.90178 19.3486L10.0213 15.2291C10.3248 14.9256 10.8168 14.9256 11.1204 15.2291C11.4239 15.5326 11.4239 16.0246 11.1204 16.3282L7.00083 20.4477C6.85529 20.5938 6.6575 20.6757 6.4513 20.6754Z",
    fill: "rgb(51,51,51)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M10.5708 20.6754C10.3718 20.6754 10.1729 20.5996 10.0213 20.4477L5.90178 16.3282C5.59825 16.0246 5.59825 15.5326 5.90178 15.2291C6.2053 14.9256 6.69731 14.9256 7.00083 15.2291L11.1204 19.3486C11.4239 19.6521 11.4239 20.1442 11.1204 20.4477C10.9748 20.5938 10.777 20.6757 10.5708 20.6754Z",
    fill: "rgb(51,51,51)",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBenefit3);
export default __webpack_public_path__ + "static/media/download-benefit-3.435919db8447cbab4b48fa04c1bbd23b.svg";
export { ForwardRef as ReactComponent };